export const ROUTE_PERMISSIONS = {
  stock: 'view_stock',
  movements: { prefix: 'view_movements_' },
  processTransfers: 'view_process_transfers',
  shipments: 'view_shipments',
  capacity: 'view_capacity',
  arrivals: 'view_arrivals',
  orders: 'view_orders',
  pullback: 'view_pullback',
  salesAnalysis: 'view_sales_analysis',
  timeToSell: ['view_time_to_sell', 'view_product_sales'],
  settings: { prefix: 'view_settings_' },
  chat: 'view_chat',
  support: null,
};

export const SIDEBAR_ROUTE_ORDER = [
  'stock',
  'movements',
  'processTransfers',
  'shipments',
  'capacity',
  'arrivals',
  'orders',
  'pullback',
  'salesAnalysis',
  'settings',
  'timeToSell',
  //'chat',
  'support',
];
